// Marks this tab as a support-agent session. It is written before the agent is
// sent to Auth0, so it is already in place when the app boots again on the
// callback, which is the only point where the session-timeout config is read.
// sessionStorage keeps it scoped to the one tab the agent launched.
const AGENT_SESSION_STORAGE_KEY = 'geisinger_agent_session';

export const startAgentSession = () => {
  try {
    sessionStorage.setItem(AGENT_SESSION_STORAGE_KEY, 'true');
  } catch {
    // Storage can be unavailable (e.g. blocked by browser settings). The token
    // claims still identify the agent; only the boot-time timeout tweak is lost.
  }
};

export const endAgentSession = () => {
  try {
    sessionStorage.removeItem(AGENT_SESSION_STORAGE_KEY);
  } catch {
    // Nothing to clear if storage is unavailable.
  }
};

export const isAgentSession = () => {
  try {
    return sessionStorage.getItem(AGENT_SESSION_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};
